<template>
    <div class="box">
        <div class="box-item" 
            :style="{
                border : (!border ? 'none !important;' : ''),
                borderColor : borderColor,
                height : height,
                padding: padding
            }">
            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: 'box',
    props: {
        border: {
            type: Boolean,
            default: true
        },
        borderColor: {
            type: String,
            default: '#ccc'
        },
        height: {
            type: String,
            default: '100%'
        },
        padding: {
            type: String,
            default: '10px'
        }
    }
}
</script>
